import axios from "axios";

export default {
  async getReport(req) {
    return await axios
      .get(`report/buying_tracking_private`, { params: req })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.response.data.message);
      });
  },
  async purchaseSummeryExcelImport(req) {
    let date_time = new Date();
    date_time = `${(date_time.getMonth() + 1).toString().padStart(2, "0")}/${date_time.getDate().toString().padStart(2, "0")}/${date_time
      .getFullYear()
      .toString()}`;
    let fileName = `PurchaseSummary Pvt-` + date_time.replaceAll(`/`, `-`);

    axios({
      method: "get",
      url: `report/download-summery-private`,
      params: req,
      responseType: "blob",
    })
      .then((res) => {
        console.log("RES", res);
        const url = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.ms-excel",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.xlsx`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        console.log(err);
        throw new Error(err.response.data.message);
      });
  },
};
